module.exports = __webpack_public_path__ + "img/button-play.311b3811.png";